import { render, staticRenderFns } from "./tab-complete.vue?vue&type=template&id=36f28422&scoped=true"
import script from "./tab-complete.vue?vue&type=script&lang=js"
export * from "./tab-complete.vue?vue&type=script&lang=js"
import style0 from "./tab-complete.vue?vue&type=style&index=0&id=36f28422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f28422",
  null
  
)

export default component.exports